import CallError from '../../../utils/CallError';
import { getBadParams, getMissingKeys } from '../../../utils/general';
import { reviewSettings } from '../setup';

/**
 * Deletes a reply
 * @param {object} params - an object of params
 * @param {string} params.accessToken - IMS access token
 * @param {string} params.imsUserId - User's IMS userId
 * @param {string} params.replyId - ID of the reply to delete
 * @param {AbortSignal} [signal] - Abort signal that can be used to abort the fetch request
 * @returns {Promise<true>}
 * @throws {CallError}
 */
export default async (params = {}, signal = null) => {
  const requiredParams = ['accessToken', 'imsUserId', 'replyId'];
  const paramsRules = {
    accessToken: { allowedTypes: ['string'] },
    imsUserId: { allowedTypes: ['string'] },
    replyId: { allowedTypes: ['string'] },
  };

  if (!reviewSettings.endpoint['delete-reply']) {
    throw new CallError('params', {}, 400, { message: 'Missing value for RNR delete-reply endpoint' });
  }
  if (!reviewSettings.apiKey) {
    throw new CallError('params', {}, 400, { message: 'Missing value for RNR api key' });
  }

  const missingParams = getMissingKeys(params, requiredParams);
  let badParams = [];
  if (Object.keys(params).length) {
    badParams = getBadParams(params, paramsRules);
  }
  if (missingParams.length || badParams.length) {
    throw new CallError('params', null, 404, { missingParams, badParams });
  }

  const { accessToken, imsUserId, replyId } = params;
  const requestUrl = reviewSettings.endpoint['delete-reply'].replace('{id}', replyId);
  const response = await fetch(requestUrl, {
    signal,
    method: 'DELETE',
    headers: {
      authorization: accessToken,
      'x-gw-ims-user-id': imsUserId,
      'x-api-key': reviewSettings.apiKey,
    },
  });
  let content = await response.text();
  try {
    content = JSON.parse(content);
  } catch (e) {
    // response is not json
  }

  if (!response.ok) {
    throw new CallError('http', content, response.status, { message: response.statusText });
  } else {
    return true;
  }
};
